import { camelCase, startCase } from 'lodash';
import aptiveAPI from './api';
export const getHistoricalRecords = (queryParams) => {
    return aptiveAPI.get(`/admin/historical-records-email`, {
        params: {
            ...queryParams,
        },
    });
};
export const getHistoricalRecordById = (id) => {
    return aptiveAPI.get(`/admin/historical-record-email/${id}`);
};
export const getHistoricalRecordFilters = () => {
    return aptiveAPI.get('/admin/historical-records-email/filters');
};
export const getEmails = (email_address, recipient) => {
    return aptiveAPI.post(`/admin/historical-records-email/autocomplete?email_address=${email_address}&recipient=${recipient}`);
};
export const getEmailTemplateNotificationTypes = () => {
    return aptiveAPI.get('/admin/email-templating-system/types');
};
export const createEmailTemplate = (data) => {
    return aptiveAPI.post('/admin/email-templating-system/templates', {
        ...data,
        status: 'A',
        notification_types: data.notification_types.map((type) => type.value),
    });
};
export const getSMSTemplate = () => {
    return aptiveAPI.get('/admin/templates-sms/all');
};
export const getSMSTemplateById = (id) => {
    return aptiveAPI.get(`/admin/templates-sms/${id}`);
};
export const getSMSTemplateTypes = () => {
    return aptiveAPI.get('/admin/templates-sms/types');
};
export const getSMSHistoricalRecordFilters = () => {
    return aptiveAPI.get('/admin/historical-records-sms/filters');
};
export const createSMSTemplate = (data) => {
    return aptiveAPI.post('/admin/templates-sms/create', {
        ...data,
        type: startCase(camelCase(data.notification_types[0])).replace(/ /g, ''),
    });
};
export const updateSMSTemplateById = (id, data) => {
    return aptiveAPI.patch(`/admin/templates-sms/${id}`, {
        ...data,
    });
};
export const getSMSHistoricalRecords = (queryParams) => {
    return aptiveAPI.get(`/admin/historical-records-sms`, {
        params: {
            ...queryParams,
        },
    });
};
export const getSMSHistoricalRecordById = (id) => {
    return aptiveAPI.get(`/admin/historical-record-sms/${id}`);
};
export const getChatHistory = (phoneNumber) => {
    return aptiveAPI.get(`/admin/historical-records-sms/chat/${phoneNumber}`);
};
